common.View.create('website::layouts.Main', {

    onDOMLoad()
    {
        this.initAnimations();
        this.initScrollButton();
    },

    initAnimations() {
        let sal = require('sal.js');

        sal({
            threshold: 0.1,
            once: true,
        });
    },

    initScrollButton() {
        // Get scroll button and add listener
        this.element.find('.scroll-button').click((e) => {

            // Just scroll to main content
            $([document.documentElement, document.body]).animate({
                scrollTop: $(".main").offset().top + 10
            }, 500);

            // Prevent default link behaviour
            e.preventDefault();
        });
    }
});
